import axios from 'axios'
import storage from '@/store/localstorage.js'
import store from '@/store'

const http = axios.create({
  // for cors
  withCredentials: true
})

http.interceptors.request.use((config) => {
  // console.log(config.url)
  // console.log('params', config.data)
  return config
})

http.interceptors.response.use(function (response) {
  // console.log('response::' + response.config.url)
  // console.log(response)
  if (response.data) {
    return response
  } else {
    window.toastr.error('予期せぬエラーが発生しました')
  }
}, function (error) {
  // 認証エラー時の処理
  console.error('error')
  console.log(error.response)
  if (error.response.status === 401) {
    window.toastr.warning('ログインが必要です')

    setTimeout(function () {
      if (store.getters['User/isLogged'] && location.pathname !== '/login') {
        storage.removeAll()
        location.href = '/login'
      }
      if (store.getters['WarehouseUser/isLogged'] && location.pathname !== '/warehouse-login') {
        storage.removeAll()
        location.href = '/warehouse-login'
      }
    }, 200)
    // システムエラー時の処理
  } else if (error.response.status === 500) {
    window.toastr.error('予期せぬエラーが発生しました')
    // return Promise.reject(error)
  }
  // return Promise.reject(error)
})

export default http
